import { render, staticRenderFns } from "./ErgoEval.vue?vue&type=template&id=45e1a654"
import script from "./ErgoEval.vue?vue&type=script&lang=js"
export * from "./ErgoEval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports